import React, { Component } from 'react';
import { connect } from 'react-redux';
import Loading from '../../../common/components/Loading/Loading';
import UpdateJobs from './UpdateJobs';
import Store from '../../../redux/Store';
import Constants from '../../../common/constants/Constants';
import DeploymentStateEnum from '../../../common/constants/DeploymentStateEnum';
import { showSnackbar } from '../../../common/state/snackbar/Snackbar.actions';
import { getUpdateJobs } from './UpdateJobActions';
import { withRouter } from '../../../common/utils/NavigationWrapper';

class UpdateJobsContainer extends Component {
  constructor(props) {
    super();
    this.state = {
      data: [],
      isFetching: true,
    };

    this.columnConfigs = [
      {
        name: 'Package name',
        key: 'Name',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Description',
        key: 'Description',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Type',
        key: 'Type',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Version',
        key: 'Version',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Instruments',
        key: 'AmountInstruments',
        type: 'number',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Target instrument type',
        key: 'InstrumentType',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Job start date',
        key: 'JobStartDate',
        type: 'datetime',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Notified',
        key: 'Notified',
        type: 'number',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Transfer started',
        key: 'TransferStarted',
        type: 'number',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Transfer completed',
        key: 'TransferCompleted',
        type: 'number',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Installation started',
        key: 'InstallationStarted',
        type: 'number',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Installation completed',
        key: 'InstallationCompleted',
        type: 'number',
        visible: false,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Reported failures',
        key: 'AmountFailedUpdates',
        type: 'number',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Job finish date',
        key: 'JobFinishDate',
        type: 'datetime',
        visible: true,
        filterable: true,
        sortable: true,
      },
    ];
  }

  componentDidMount() {
    let data = null;

    getUpdateJobs()
      .then((res) => {
        data = res.body;
        this.setState({ data: res.body, isFetching: false });
      })
      .catch((err) => {
        this.setState({ isFetching: false });
        Store.dispatch(
          showSnackbar({
            type: Constants.SNACKBAR_MESSAGE_TYPES.ERROR,
            message: 'Failed to load deployment jobs.',
          })
        );
      });
  }

  componentDidUpdate(prevProps) {
    if (
      JSON.stringify(prevProps.packageDeploymentMessage) !==
      JSON.stringify(this.props.packageDeploymentMessage)
    ) {
      this._handlePackageDeploymentMessage(this.props.packageDeploymentMessage);
    }
  }

  _handlePackageDeploymentMessage = (message) => {
    const {
      CommandGuid,
      DeploymentState,
      Error,
      ErrorMessage,
      DeploymentStateTime,
      JobFinishTime,
    } = JSON.parse(message.data);

    let copiedState = [...this.state.data];

    const updateJobIndex = copiedState.findIndex((job) =>
      job.PackageDeployments.find((x) => x.CommandGuid == CommandGuid)
    );

    if (updateJobIndex === -1) {
      // ignore the message in case the update job isn't loaded
      return;
    }

    let deploymentIndex = copiedState[updateJobIndex].PackageDeployments.findIndex(
      (x) => x.CommandGuid == CommandGuid
    );

    if (typeof JobFinishTime == 'undefined') {
      copiedState[updateJobIndex].FinishTime = null;
    } else {
      copiedState[updateJobIndex].FinishTime = JobFinishTime;
    }

    copiedState[updateJobIndex].PackageDeployments[deploymentIndex] = {
      ...copiedState[updateJobIndex].PackageDeployments[deploymentIndex],
      State: DeploymentState,
      Error: Error,
      ErrorMessage: ErrorMessage,
      StateTime: DeploymentStateTime,
    };
    this.setState({ data: copiedState });
  };

  _adjustProperties = (data) => {
    let adjustedUpdateJobs = [];

    data.forEach((updateJob) => {
      let newJob = {};

      if (updateJob.PackageDeployments[0] != undefined) {
        newJob.PackageName = updateJob.PackageDeploymentJobId;
        newJob.Name = updateJob.Name;
        newJob.Description = updateJob.PackageDeployments[0].Package.Description;
        newJob.Type = updateJob.PackageDeployments[0].Package.Type;
        newJob.Version = updateJob.PackageDeployments[0].Package.Version;
        newJob.AmountInstruments = updateJob.PackageDeployments.length;
        newJob.InstrumentType = updateJob.PackageDeployments[0].Package.InstrumentType;
        newJob.JobStartDate = updateJob.StartTime;
        newJob.Notified = this._count(
          updateJob.PackageDeployments,
          'State',
          DeploymentStateEnum.FILE_AVAILABLE_MESSAGE_SENT
        );
        newJob.TransferStarted = this._count(
          updateJob.PackageDeployments,
          'State',
          DeploymentStateEnum.TRANSFER_STARTED
        );
        newJob.TransferCompleted = this._count(
          updateJob.PackageDeployments,
          'State',
          DeploymentStateEnum.TRANSFER_COMPLETED
        );
        newJob.InstallationStarted = this._count(
          updateJob.PackageDeployments,
          'State',
          DeploymentStateEnum.INSTALLATION_STARTED
        );
        newJob.InstallationCompleted = this._count(
          updateJob.PackageDeployments,
          'State',
          DeploymentStateEnum.INSTALLATION_COMPLETED
        );
        newJob.AmountFailedUpdates = this._count(updateJob.PackageDeployments, 'Error', true);
        newJob.JobFinishDate = updateJob.FinishTime;

        adjustedUpdateJobs.push(newJob);
      }
    });

    return adjustedUpdateJobs;
  };

  _count = (dataset, objValue, compareValue) => {
    const count = dataset.reduce((counter, obj) => {
      if (obj[objValue] === compareValue) counter += 1;
      return counter;
    }, 0);

    return count;
  };

  render() {
    return (
      <Loading condition={this.state.isFetching}>
        <div>
          <UpdateJobs
            data={this._adjustProperties(this.state.data)}
            columnConfigs={this.columnConfigs}
            onClickRow={this._onClickRowCallback}
            newUpdateJob={this._onClickNewUpdateJob}
          />
        </div>
      </Loading>
    );
  }

  _onClickRowCallback = (el) => {
    const { navigate } = this.props;
    navigate(`/update-job/${el.PackageName}`);
  };

  _onClickNewUpdateJob = () => {
    const { navigate } = this.props;
    navigate(`/update-job-creator/`);
  };
}

const mapStateToProps = (state) => ({
  packageDeploymentMessage:
    state.push.pushMessages != null
      ? state.push.pushMessages.find((el) => el.type === 'PackageDeploymentFeedback')
      : null,
});

export default withRouter(connect(mapStateToProps)(UpdateJobsContainer));
